import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { Options } from 'ngx-slider-v2';

import * as _ from 'lodash-es';

declare var require: any;
declare var mapboxgl: any;
declare var turf: any;
declare var google: any;

@Component({
  selector: 'app-worker-safetyzone',
  templateUrl: './worker-safetyzone.component.html',
  styleUrls: ['./worker-safetyzone.component.scss']
})
export class WorkerSafetyzoneComponent implements OnInit {

  @Input() worker:any;

  @Output() refreshWorker = new EventEmitter();

  create = false;
  changed = false;

  map: any;
  center: any;
  circle: any;
  marker:any

  radius: number = 100;

  // zone = {
  //   zone_lat: 0,
  //   zone_lng: 0,
  //   zone_radius: 0
  // };

  zoneGroup = new FormGroup({
    zone_lat: new FormControl(0,[]),
    zone_lng: new FormControl(0,[]),
    zone_radius: new FormControl(0,[])
  });

  options: Options = {
    floor: 100,
    tickStep: 50,
    ceil: 10000
  }

  zoom = 12;
  hide_map = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    this.getWorker();

  }

  getWorker(){

    this.okService.get("workers/"+this.worker.id,{expand: "status"})
    .subscribe((data) => {

      this.worker = data.body;
      //console.log(this.worker);

      this.setWorker();

    });
  }

  setWorker(){
    this.zoneGroup.setValue({
      zone_lat: this.worker.zone_lat,
      zone_lng: this.worker.zone_lng,
      zone_radius: this.worker.zone_radius
    });

    //console.log('zoneGroup',this.zoneGroup.value);

    if(this.zoneGroup.value.zone_radius && this.zoneGroup.value.zone_radius > 0){
      this.setupMap();
    }

    //console.log(this.zoneGroup.value);
  }

  createZone(){

    console.log("createZone()");


    this.okService.get("account/location",{})
    .subscribe((data:any) => {

      console.log(data.body);

      this.zoneGroup.patchValue({
        zone_lat: data.body['lat'],
        zone_lng:  data.body['lng'],
        zone_radius: 500
      });
      //this.create = true;
      this.setupMap();


    });


  }

  setupMap(){

    //console.log("Shift map");
    this.hide_map = false;

    mapboxgl.accessToken = 'pk.eyJ1IjoidHJ1c3R5b3giLCJhIjoiY2wxY2Y0emQ1MDcwOTNwcDNxYTd3ODB1ZyJ9.moSeRr49cY5d14hosZeT1w';
    this.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [this.zoneGroup.value.zone_lng,this.zoneGroup.value.zone_lat],
        zoom: this.zoom,
    });
    this.map.addControl(new mapboxgl.FullscreenControl());
    this.map.addControl(new mapboxgl.NavigationControl());

    this.map.on('click', (e:any) => {


      //console.log(e.lngLat);

      const {lng, lat} = e.lngLat;
      //console.log(lat,lng);

      this.zoneGroup.patchValue({
        zone_lat: lat.toFixed(6),
        zone_lng: lng.toFixed(6),
        zone_radius: this.zoneGroup.value.zone_radius == 0 ? 500 : this.zoneGroup.value.zone_radius
      });
      this.setCircle();

      this.changed = true;
    });


    this.map.on('load', () => {

      //this.setMarkers();
      this.setCircle();

    });
  }

  setCircle(){

    if(this.zoneGroup.value.zone_radius && this.zoneGroup.value.zone_radius > 0){

      // this.marker = new mapboxgl.Marker({"color":color"})
      // .setLngLat([this.zoneGroup.value.zone_lng,this.zoneGroup.value.zone_lat])
      // .addTo(this.map);

      var center = turf.point([this.zoneGroup.value.zone_lng,this.zoneGroup.value.zone_lat]);
      var options = {
        steps: 80,
        units: 'meters'
      };

      this.circle = turf.circle(center, this.zoneGroup.value.zone_radius, options);

      //console.log(this.circle);
      //console.log(this.zone);

      if(this.map.getLayer('circle-fill')){
        this.map.removeLayer('circle-fill');
        this.map.removeSource('circle-fill');
      }

      this.map.addLayer({
        "id": "circle-fill",
        "type": "fill",
        "source": {
            "type": "geojson",
            "data": this.circle
        },
        "paint": {
            "fill-color": "green",
            "fill-opacity": 0.5
        },
      });
    }


  }

  changeRadius(){
    console.log(this.radius);
    this.changed = true;
    this.setCircle();
  }


  save(){

    this.okService.put("workers/"+this.worker.id,this.zoneGroup.value)
    .subscribe((data) => {

      //console.log('save return',data.body);
      this.okService.setAlert(this.transloco.translate("The worker zone has been updated"),"success");

      this.changed = false;

      this.getWorker();

    });
  }

  cancel(){
    this.create = false;
    this.zoneGroup.patchValue({
      zone_lat: 0,
      zone_lng: 0,
      zone_radius: 0
    });

    this.okService.put("workers/"+this.worker.id,this.zoneGroup.value)
    .subscribe((data) => {

      this.okService.setAlert(this.transloco.translate("The worker zone has been cancelled"),"success");

      this.hide_map = true;

    });

  }

  goToLatLng(){
    this.map.flyTo({
      center: [this.zoneGroup.value.zone_lng,this.zoneGroup.value.zone_lat],
      zoom: 10
    });
  }

}
